<template>
  <div id="contenedor-editar-contrato-gasto">
    <v-form
      v-model="formularioValido"
      ref="editarContratoGasto">
      <v-card>
        <v-card-title>
          Editar Gasto
          <v-spacer></v-spacer>
          <v-btn icon @click="cerrar">
            <v-icon class="secondary--text" large>highlight_off</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-row>
            <text-field
              v-model="gasto.numero"
              label="Número"
              cols="12"
              :rules="[mixReglas.requerido]">
            </text-field>
            <date-picker
              v-model="gasto.fechaDel"
              label="Fecha Del"
              :rules="[mixReglas.requerido]"
              cols="12"
              md="6">
            </date-picker>
            <date-picker
              v-model="gasto.fechaAl"
              label="Fecha Al"
              :rules="[mixReglas.requerido]"
              cols="12"
              md="6">
            </date-picker>
            <v-col
              cols="12">
              <v-divider></v-divider>
            </v-col>
            <custom-text-field-green
              cols="12"
              md="8"
              v-model.number="gasto.importe"
              label="Importe"
              es-dinero
              prefix="$"
              :rules="[mixReglas.requerido]"
              @keyup="calcularTotal">
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="4"
              v-model.number="gasto.porcentajeIva"
              label="% I.V.A."
              suffix="%"
              es-dinero
              :rules="[mixReglas.requerido]"
              @keyup="calcularTotal">
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="6"
              v-model="gasto.iva"
              label="Importe I.V.A."
              prefix="$"
              es-dinero
              readonly
              disabled>
            </custom-text-field-green>
            <custom-text-field-green
              cols="12"
              md="6"
              v-model="gasto.total"
              es-dinero
              label="Total"
              prefix="$"
              readonly
              disabled>
            </custom-text-field-green>
            <v-col
              cols="12">
              <v-divider></v-divider>
            </v-col>
            <text-area
              v-model="gasto.comentarios"
              label="Comentarios"
              rows="2">
            </text-area>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <custom-button
            @click="cerrar"
            tipo="formCancelar"
            label="Cancelar"
            class="mr-3">
          </custom-button>
          <custom-button
            @click="mixActualizarGastos"
            :disabled="!formularioValido || enviandoFormulario"
            :loading="enviandoFormulario"
            tipo="formAceptar"
            label="Guardar">
          </custom-button>
        </v-card-actions>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import mixContratosGastos from './mixContratosGastos';
import TextField from '@/components/inputs/TextField.vue';
import CustomTextFieldGreen from '@/components/inputs/TextFieldGreen.vue';
import DatePicker from '@/components/inputs/DatePicker.vue';
import TextArea from '@/components/inputs/TextArea.vue';
import CustomButton from '@/components/buttons/Button.vue';

export default {
  name: 'EditarContratoGasto',
  mixins: [mixContratosGastos],
  components: {
    TextField,
    CustomTextFieldGreen,
    DatePicker,
    CustomButton,
    TextArea,
  },
  props: {
    gastoEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      gasto: {
        numero: this.gastoEditar.numero,
        fechaDel: this.gastoEditar.fechaDel,
        fechaAl: this.gastoEditar.fechaAl,
        importe: this.gastoEditar.importe,
        porcentajeIva: this.gastoEditar.porcentajeIva,
        iva: this.gastoEditar.iva,
        total: this.gastoEditar.total,
        comentarios: this.gastoEditar.comentarios,
      },
    };
  },
  methods: {
    calcularTotal() {
      const {
        importe, porcentajeIva,
      } = this.gasto;
      if (importe <= 0) return;

      this.gasto.iva = this.$numberRoundDigits((importe * (porcentajeIva / 100)), 2);
      this.gasto.total = (this.gasto.iva + importe);
    },
    limpiarFormulario() {
      this.$refs.editarContratoGasto.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
  },
};
</script>

<style lang="scss">

</style>
